import {Modal, Image} from "antd";
import React from "react";

interface CategoryPictureProps {
    pictureUrl: string | undefined,
    visible: boolean,
    setVisible: (visible: boolean) => void
}

const CategoryPicture: React.FC<CategoryPictureProps> = ({pictureUrl, visible, setVisible}) => {

    return <Modal
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
        centered
        mask={true}
    >
        <Image src={pictureUrl}/>
    </Modal>

}

export default CategoryPicture;